<template>
  <a-modal
    :visible="visible"
    :title="$t('sms.confirmSendTitle')"
    @ok="$emit('confirm')"
    @cancel="$emit('cancel')"
    :okText="$t('sms.envoyer')"
    :cancelText="$t('all.cancel')"
    :width="550"
    :okButtonProps="{
      props: {
        loading: loading,
        disabled: !summary || summary.totalValidPhones === 0,
      },
    }"
  >
    <div v-if="summary && summary.entries.length > 0">
      <a-table
        :columns="tableColumns"
        :dataSource="summary.entries"
        :rowKey="(record, index) => index"
        :pagination="false"
        :scroll="{ y: 300 }"
        size="small"
      >
        <template slot="phones" slot-scope="phones">
          <div
            v-for="(p, i) in phones"
            :key="i"
            :class="{ 'mt-1': i > 0 }"
          >
            <span>{{ p.phone }}</span>
            <a-tag
              v-if="p.label"
              :color="tagColor(p.label)"
              class="ml-1"
              style="font-size: 11px"
            >{{ p.label }}</a-tag>
          </div>
        </template>
      </a-table>
      <div class="mt-3 d-flex justify-content-between align-items-center">
        <div>
          <span
            v-if="summary.totalInvalid > 0"
            class="text-danger mr-3"
          >
            <a-icon type="close-circle" class="mr-1" />{{
              summary.totalInvalid
            }}
            {{ $t("sms.invalidPhones") }}
          </span>
          <span
            v-if="summary.totalDuplicates > 0"
            style="color: #faad14"
          >
            <a-icon type="warning" class="mr-1" />{{
              summary.totalDuplicates
            }}
            {{ $t("sms.duplicatePhones") }}
          </span>
        </div>
        <span class="font-weight-bold">
          {{ $t("sms.confirmTotalLabel") }}:
          <span class="text-primary font-size-18 ml-2">{{ totalSms }}</span>
        </span>
      </div>
    </div>
    <div v-else class="text-center text-muted py-4">
      {{ $t("sms.noValidNumbers") }}
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "SmsConfirmModal",
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    summary: { type: Object, default: null },
    totalSms: { type: Number, default: 0 },
  },
  computed: {
    tableColumns() {
      return [
        {
          title: this.$t("sms.destinataire"),
          dataIndex: "name",
          key: "name",
          customRender: (name, record) => name || record.destinataire || "—",
        },
        {
          title: this.$t("sms.telephone"),
          dataIndex: "phones",
          key: "phones",
          scopedSlots: { customRender: "phones" },
        },
      ];
    },
  },
  methods: {
    tagColor(label) {
      if (label === this.$t("sms.pere")) return "blue";
      if (label === this.$t("sms.mere")) return "pink";
      if (label === this.$t("sms.guardian")) return "green";
      if (label === this.$t("emploi.teacher")) return "cyan";
      return "default";
    },
  },
};
</script>
